import { render } from "./FeedBackTestSamoprocena.vue?vue&type=template&id=8ed34b3c&scoped=true&lang=html"
import script from "./FeedBackTestSamoprocena.vue?vue&type=script&lang=js"
export * from "./FeedBackTestSamoprocena.vue?vue&type=script&lang=js"

import "./FeedBackTestSamoprocena.vue?vue&type=style&index=0&id=8ed34b3c&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-8ed34b3c"

export default script